<template>
	<OrganismBanner
		title="Een nieuwe groep MamaFit gaat starten!"
		subtitle="Train samen met andere vrouwen om gezond en fit door je zwangerschap heen te gaan en na je zwangerschap weer snel te herstellen."
		:to="{
			url: '/mamafit',
			title: 'Meld je aan voor MamaFit',
		}"
		button-text="Start met MamaFit"
		button-icon="fa-heart"
		color="pink"
	/>
</template>
